import { useCallback } from "react";

const useMessageHandlers = ({
  setSelectedDiffLines,
  setDiffComments,
  setAdoptedExpertOpinions,
}) => {
  const handleDiffLineClick = useCallback((messageIndex, lineIndex) => {
    setSelectedDiffLines((prevSelected) => {
      const messageLines = prevSelected[messageIndex] || [];
      return {
        ...prevSelected,
        [messageIndex]: messageLines.includes(lineIndex)
          ? messageLines.filter((line) => line !== lineIndex)
          : [...messageLines, lineIndex],
      };
    });
  }, [setSelectedDiffLines]);

  const handleCommentChange = useCallback((messageIndex, lineIndex, comment) => {
    setDiffComments((prevComments) => ({
      ...prevComments,
      [messageIndex]: {
        ...(prevComments[messageIndex] || {}),
        [lineIndex]: comment,
      },
    }));
  }, [setDiffComments]);

  const handleOpinionAdoption = useCallback((messageIndex, lineIndex, isAdopted) => {
    setAdoptedExpertOpinions((prev) => {
      const messageOpinions = prev[messageIndex] || [];
      const updatedOpinions = isAdopted
        ? [...messageOpinions, lineIndex]
        : messageOpinions.filter((i) => i !== lineIndex);

      return {
        ...prev,
        [messageIndex]: updatedOpinions,
      };
    });
  }, [setAdoptedExpertOpinions]);

  return {
    handleDiffLineClick,
    handleCommentChange,
    handleOpinionAdoption,
  };
};

export default useMessageHandlers;
